import React, { useState } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <Link
        to="home"
        className="nav-logo-container"
        smooth={true}
        duration={500}
        onClick={closeMenu}
      >
        <span className="nav-logo-name">Carles Falcó</span>
        <img
          src="/logo_transparent.png"
          alt="Carles Falco Logo"
          className="nav-logo-icon"
        />

      </Link>

      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        &#9776;
      </div>

      <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <Link
            to="home"
            className="nav-link"
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={closeMenu}
          >
            // Home
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="about"
            className="nav-link"
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={closeMenu}
          >
            // About
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="education"
            className="nav-link"
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={closeMenu}
          >
            // Education
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="projects"
            className="nav-link"
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={closeMenu}
          >
            // Projects
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="contact"
            className="nav-link"
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={closeMenu}
          >
            // Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;